import { ReservationType } from '@/lib/types/reservation';
import type { VisitorType } from '@/lib/types/visitor';

export { ReservationType };

export interface CalendarFilters {
    reservationType: ReservationType | null;
    resourceTypeIds: string[];
    resourceIds: string[];
    visitorTypes: VisitorType[];
    showOnlyMyReservations: boolean;
    showMaintenance: boolean;
}

export function createDefaultCalendarFilters(): CalendarFilters {
    return {
        reservationType: null,
        resourceTypeIds: [],
        resourceIds: [],
        visitorTypes: [],
        showOnlyMyReservations: false,
        showMaintenance: true
    };
}
